
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/republic-of-ireland-tcs",
      function () {
        return require("private-next-pages/republic-of-ireland-tcs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/republic-of-ireland-tcs"])
      });
    }
  